module.exports = __webpack_public_path__ + "static/media/quadro_p6000@2x.0ca74ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/workstation/quadro_p6000@2x.png
// module id = 316
// module chunks = 0